"use client";

import { Suspense, useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { installHistoryNavTracker, syncHistoryIndex } from "@/lib/historyNav";

/**
 * Pasang pelacak riwayat navigasi (`src/lib/historyNav.ts`) sekali di root:
 * listener `popstate` untuk deteksi traversal (beranda memulihkan posisi feed
 * hanya saat tiba lewat Kembali/Maju) dan stempel indeks riwayat tiap rute
 * berganti (panah Kembali di halaman produk tahu apakah `history.back()`
 * masih di dalam situs). Tanpa UI. Dipisah dari TopLoader supaya indikator
 * memuat dan memori navigasi tak saling bergantung.
 */
function RouteIndexSync() {
  const pathname = usePathname();
  const search = useSearchParams().toString();

  // Passive effect: `HistoryUpdater` Next menulis `history.state` entri baru
  // di insertion effect commit yang sama, jadi di sini state-nya sudah final.
  useEffect(() => {
    syncHistoryIndex();
  }, [pathname, search]);

  return null;
}

export function HistoryNavTracker() {
  // Mengembalikan fungsi pelepas → jadi cleanup effect.
  useEffect(() => installHistoryNavTracker(), []);

  return (
    // `useSearchParams` wajib di bawah Suspense (pola RouteChangeWatcher di TopLoader).
    <Suspense fallback={null}>
      <RouteIndexSync />
    </Suspense>
  );
}
